import React from 'react';
import Drawer from 'material-ui/Drawer';
import {spacing, typography} from 'material-ui/styles';
import {white, blue600} from 'material-ui/styles/colors';
import MenuItem from 'material-ui/MenuItem';
import {Link} from 'react-router-dom'
import Avatar from 'material-ui/Avatar';
import {ListItem} from "material-ui";

const LeftDrawer = (props) => {
    let {navDrawerOpen} = props;

    const styles = {
        logo: {
            cursor: 'pointer',
            fontSize: 22,
            color: typography.textFullWhite,
            lineHeight: `${spacing.desktopKeylineIncrement}px`,
            fontWeight: typography.fontWeightLight,
            backgroundColor: blue600,
            paddingLeft: 40,
            height: 56,
        },
        menuItem: {
            color: white,
            fontSize: 14
        },
        avatar: {
            div: {
                padding: '15px 0 20px 15px',
                backgroundColor: 'black',
                height: 100
            },
            icon: {
                float: 'left',
                display: 'block',
                marginRight: 15,
                boxShadow: '0px 0px 0px 8px rgba(0,0,0,0.2)'
            },
            span: {
                paddingTop: 12,
                display: 'block',
                color: 'white',
                fontWeight: 400,
                textShadow: '1px 1px #444'
            },
            emailText: {
                fontSize: 12,
                paddingTop: 12,
                display: 'block',
                color: 'white',
                fontWeight: 200,
                textShadow: '1px 1px #444'
            }
        }
    };

    return (
        <Drawer
            width={200}
            docked={true}
            open={navDrawerOpen}>
            <div style={styles.logo}>
                Meniu
            </div>
            <div style={styles.avatar.div}>
                <span style={styles.avatar.span}>{props.username}</span>
                <span style={styles.avatar.emailText}>{props.email}</span>
            </div>
            <div>
                {props.menus.map((menu, index) =>
                    <ListItem
                        key={index}
                        style={{...styles.menuItem, textAlign: 'left'}}
                        primaryText={menu.text}
                        rightAvatar={menu.icon}
                        containerElement={<Link to={menu.link}/>}
                    />
                )}
            </div>
        </Drawer>
    );
};

export default LeftDrawer;